import { useCallback, useState } from "react";
import adminApi from "../api/adminApi";
import { isSameData } from "../utils/adminUtils";

export default function useUsers(setBanner) {
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

  const loadUsers = useCallback(async (silent = false) => {
    if (!silent) setUsersLoading(true);

    try {
      const data = await adminApi.getUsers();
      const next = Array.isArray(data) ? data : [];
      setUsers((prev) => (isSameData(prev, next) ? prev : next));
    } catch (error) {
      setBanner({ type: "error", text: error.message || "Failed to load users" });
    } finally {
      if (!silent) setUsersLoading(false);
    }
  }, [setBanner]);

  return {
    users,
    usersLoading,
    loadUsers,
  };
}